import { ObservationAttachment } from '../../AttachmentArbiter/Attachment';
import { createRenderingTracker, trackingKey } from '../createRenderingTracker';

/**
 * Why a tracker for observations?
 * Impressions often cite several lab observations that all point at the
 * same biomarker (e.g. multiple LDL results across visits). Each citation
 * would otherwise render its own chart and crowd the report with
 * essentially-identical visualizations. This tracker keeps the first chart
 * for a given biomarker and silences the rest within a single
 * impression-type section.
 *
 * Why include `summaryType` in the key?
 * The same biomarker can be legitimately discussed under different
 * impression types (heart, cancer, ...). A given chart is only "duplicate"
 * within the same section, so the impression type is part of the identity.
 */
export type ObservationTrackerInput = {
  attachment: ObservationAttachment;
  summaryType: string;
};

const getObservationKey = ({
  attachment,
  summaryType,
}: ObservationTrackerInput) => {
  const code = attachment.primaryCode;
  if (!code) return null;
  return trackingKey(`${code.key}|${code.system}|${summaryType}`);
};

const handle =
  createRenderingTracker<ObservationTrackerInput>(getObservationKey);

export const ObservationTrackingProvider = handle.Provider;
export const useObservationTracker = handle.useTracker;
